import AdvancedSettingsRestService from '../rest/AdvancedSettingsRestService'
import { TFunction } from 'i18next'

class AdvancedSettingsService {
  static async get() {
    return AdvancedSettingsRestService.get()
  }

  static async retoreDefaults(setting: any, t: TFunction, setAdvancedSettings: React.Dispatch<any>) {
    try {
      await AdvancedSettingsRestService.updateGroup(setting.groupName, [])
      const advancedSetting = await AdvancedSettingsService.get()
      setAdvancedSettings(advancedSetting)
      return t('advancedSettings.restoreDefaultsSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async updateSetting(setting: any, t: TFunction, setAdvancedSettings: React.Dispatch<any>) {
    try {
      const name = Array.isArray(setting.name) ? setting.name[0] : setting.name
      var properties = Object.assign({}, setting)
      properties.name = name
      properties.value = setting[name]
      await AdvancedSettingsRestService.updateSetting(properties)
      const advancedSetting = await AdvancedSettingsService.get()
      setAdvancedSettings(advancedSetting)
      return t('advancedSettings.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default AdvancedSettingsService
